import React, { useState, useCallback, useMemo, createContext, useContext } from 'react';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var i = Object.prototype.hasOwnProperty,
    r = function a(r, e) {
  var n = [];

  for (var o in r) {
    if (i.call(r, o)) {
      var A,
          c = r[o],
          s = encodeURIComponent(o);
      A = "object" == typeof c ? a(c, e ? e + "[" + s + "]" : s) : (e ? e + "[" + s + "]" : s) + "=" + c, n.push(A);
    }
  }

  return n.join("&");
};

function indexFiltersByKey(filters) {
  return filters.reduce(function (result, _ref) {
    var initialValue = _ref.initialValue,
        filter = _objectWithoutPropertiesLoose(_ref, ["initialValue"]);

    // @ts-ignore
    result[filter.key] = _extends({}, filter, {
      value: initialValue || null
    });
    return result;
  }, {});
}
var createSearchQuery = function createSearchQuery(data) {
  return r(data);
};

function useFilters(props) {
  var _useState = useState(indexFiltersByKey(props)),
      filters = _useState[0],
      setFilters = _useState[1];
  /**
   * Reset filters to initial values
   */


  var resetFilters = useCallback(function () {
    setFilters(indexFiltersByKey(props));
  }, [props]);
  var updateFilter = useCallback(function (key, value, newOperator) {
    setFilters(function (currentFilters) {
      var _extends2, _extends4;

      var operator = newOperator || currentFilters[key].operator;

      switch (operator || currentFilters[key].operator) {
        case 'iLike':
        case 'like':
          return _extends({}, currentFilters, (_extends2 = {}, _extends2[key] = _extends({}, currentFilters[key], {
            operator: operator,
            value: value ? "%25" + value + "%25" : null
          }), _extends2));

        default:
          if (Array.isArray(value) && !(value != null && value.length)) {
            var _extends3;

            return _extends({}, currentFilters, (_extends3 = {}, _extends3[key] = _extends({}, currentFilters[key], {
              operator: operator,
              value: null
            }), _extends3));
          }

          return _extends({}, currentFilters, (_extends4 = {}, _extends4[key] = _extends({}, currentFilters[key], {
            operator: operator,
            value: value
          }), _extends4));
      }
    });
  }, []);
  /**
   * Transform filters to string
   */

  var filtersString = useMemo(function () {
    return createSearchQuery(Object.values(filters));
  }, [filters]);
  var getFilterByKey = useCallback(function (key) {
    var _filters$key;

    return (_filters$key = filters[key]) == null ? void 0 : _filters$key.value;
  }, [filters]);
  var filteredFilters = useMemo(function () {
    return Object.values(filters).filter(function (_ref) {
      var value = _ref.value;
      return value;
    });
  }, [filters]);
  return {
    filters: filteredFilters,
    resetFilters: resetFilters,
    updateFilter: updateFilter,
    filtersString: filtersString,
    getFilterByKey: getFilterByKey
  };
}

var Context = createContext(null);
function FiltersProvider(_ref) {
  var children = _ref.children,
      filters = _ref.filters;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: filters
  }, children);
}
function useFilterContext() {
  return useContext(Context);
}

export default useFilters;
export { FiltersProvider, useFilterContext };
//# sourceMappingURL=index.js.map
